import $ from 'jquery';

const getRandom = (_min, _max) => {
  const min = Math.ceil(_min);
  const max = Math.floor(_max);
  return Math.floor(Math.random() * (max - min)) + min;
};

export default class Quote {
  constructor(element) {
    this.$element = $(element);
    this.random = getRandom(0, this.total);
    this.preprocess();
    this.update();
    this.ready();
  }

  preprocess() {
    this.$quotes.eq(this.random).find('.node-header a').children().unwrap();
  }

  update() {
    const $randomQuote = this.$quotes.eq(this.random);
    this.$quotes.not($randomQuote).hide();
  }

  ready() {
    this.$element.addClass('ready');
  }

  get total() {
    return this.$quotes.length;
  }

  get $quotes() {
    return this.$element.find('.node');
  }
}
